import React, { FC, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonFooter, useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react'
import { cartMobx, doComboMobx, doProductMobx, productSaleMobx, storeMobx, restaurantConfig } from 'restaurant'
import { decorationMobx, timePickMobx, eatTypeStatusMobx } from '@mobxStore'
import { showMsg, useHistoryNew, modalLayer, toastLayer } from '@utils'
import { BackPageBtn } from '@cps'
import { AboardFixedGroup, AboardOptionalGroup, DetailInfo, Footer, Reserve } from '../'
import SelectProductModal from '../AboardOptionalGroup/SelectProductModal'
import CashierController from 'controllers/cashierController'
import TimePickController from '@ctrls/timePickController'
import { classNames, useThrottle } from '@dt/fe-utils'
import AboardOptionalGroupCart from '../AboardOptionalGroup/Cart'
import './index.scss'

interface IProps {
  isModal?: boolean;
  maxCnt?: number;
  showInfo?: boolean;
  targetPk?: string;
}

const ComboDetail: FC<IProps> = ({ isModal, maxCnt, showInfo, targetPk }) => {
  const doComboType = doComboMobx.doComboType
  const { name, intro, picBig, picHeight, picWidth, allergys, tags, showType = 0, pics } = doComboMobx.doCombo
  const history = useHistoryNew()
  const [scrollTop, setScrollTop] = useState(0)
  const [canScroll, setCanScroll] = useState(true)
  const isFromRecommend = history.getPrevState().includes('/recommend/')

  const isRestingStore = useMemo(() => {
    if (restaurantConfig.codeType !== 'brand' && cartMobx.info.payMode) {
      return !storeMobx.info?.inSale
    } else {
      return !(restaurantConfig.codeType === 'brand' ? (!!(timePickMobx.canPick && storeMobx.info.isMobileBookingOrder) || storeMobx.info.inSale) : storeMobx.info.inSale)
    }
  }, [storeMobx.info, cartMobx.info])

  const isCanAddCart = useMemo(() => {
    return CashierController.checkCanCart()
  }, [eatTypeStatusMobx.hasEnableEatType, storeMobx.info, timePickMobx.timePickList])

  const handleBack = () => {
    try {
      !isModal && (history && !isFromRecommend && (history.length <= 2 || !history.getPrevState()) ? history.push('/menu') : history.goBack())
      isModal && modalLayer.close('ProductDetail')
    } catch (error) { }
  }

  const handleExChange = () => {
    if (doComboMobx.doComboResult.isReady) {
      CashierController.handleAddSwapBuyToCart(doComboMobx.doCombo, targetPk, () => {
        handleBack()
      })
    } else {
      handleScollWrong()
    }
  }

  const handleOrderSwaBuy = () => {
    if (doComboMobx.doComboResult.isReady) {
      if (doComboMobx.doCombo && doComboMobx.doCombo.cnt) {
        CashierController.handleAddToCart(doComboMobx.doCombo.type, () => {
          handleBack()
        })
      } else {
        cartMobx.remove(doComboMobx.doCombo.pk)
        handleBack()
      }
    } else {
      handleScollWrong()
    }
  }

  const handleScollWrong = () => {
    const comboContent: any = document.getElementById('comboContent')
    const childNodes: any = document.querySelector(
      '.choose-modify-list'
    )?.childNodes
    const index = doComboMobx.doCombo.productGroups.findIndex(
      (group) => !group.productGroupDetails?.every(product => doComboMobx.groupNoProductPkReadyMap[product.pk])
    )
    if (comboContent && childNodes && ~index) {
      comboContent.scrollToPoint(0, childNodes[index].offsetTop, 300)
    }
    document.querySelector('ion-content').scrollToBottom()
  }

  const handleScroll = useThrottle(function (e: any) {
    const eleContainer = document.querySelector('#comboCartPanel') as any
    let offsetTop = eleContainer?.offsetTop || 0
    offsetTop > 70 ? eleContainer?.classList?.add('sticky') : eleContainer?.classList?.remove('sticky')
    if (!canScroll) return
    const scrollTop = typeof e === 'number' ? e : (e.detail?.scrollTop || 0)
    if (scrollTop < 0) {
      return false
    }
    setScrollTop(scrollTop)
  }, 100)

  const disableTogo = cartMobx.info.eatType !== 'dinein' && !doComboMobx.doComboResult.isCanTogo

  const disableReserve = timePickMobx.canBookingTime && timePickMobx.productRuleMap?.[doComboMobx.doCombo.no] && !timePickMobx.productTimePickList?.length

  useEffect(() => {
    if (timePickMobx.productRuleMap?.[doComboMobx.doCombo.no]) {
      TimePickController.handleInitProduct(doComboMobx.doCombo.no)
    }
  }, [doComboMobx.doCombo, timePickMobx.productRuleMap?.[doComboMobx.doCombo.no]])

  useIonViewWillEnter(() => {
    setCanScroll(true)
  }, [])

  useIonViewDidLeave(() => {
    setCanScroll(false)
  }, [])

  return (
    <>
      <IonContent
        scrollEvents
        id='productContent'
        onIonScroll={handleScroll}
      >
        {isModal ? <div className='detail-page-mask' data-cypid='comboDetailClose' onClick={handleBack}></div> : <BackPageBtn />}
        {showInfo && (
          <DetailInfo
            no={doComboMobx.doCombo.no}
            imgUrl={picBig}
            picHeight={picHeight}
            picWidth={picWidth}
            pics={pics}
            name={name}
            intro={intro}
            allergys={allergys}
            tags={tags}
            showType={showType}
            type={doComboType}
            statSaleCnt={
              decorationMobx.mealDecorates.showMonthSales ? doComboMobx.doCombo.statSaleCnt : 0
            }
            inventoryCnt={
              decorationMobx.mealDecorates.showSalesCnt ? productSaleMobx.productNoToScaleCntMap[doComboMobx.doCombo.no]?.cnt : 0
            }
            hasFullOperate={!!picBig}
            showDefaultPic={!picBig}
            isCanTogo={doComboMobx.doComboResult.isCanTogo}
            scrollTop={scrollTop}
            isCombo
            isModal={isModal}
          >
            {doComboType === 'FixedCombo' && <AboardFixedGroup />}
            {doComboType === 'OptionalCombo' && <AboardOptionalGroup />}
            {
              !Config.buyTogetherId ? (
                <Reserve
                  no={doComboMobx.doCombo.no}
                  startTime={doComboMobx.doCombo.startTime}
                  pickTimeRange={doComboMobx.doCombo.pickTimeRange}
                  onChange={({ startTime, pickTimeRange }) => {
                    doComboMobx.setStartTime(startTime, pickTimeRange)
                  }}
                />
              ) : <></>
            }
          </DetailInfo>
        )}
      </IonContent>
      {targetPk || doComboMobx.doCombo.isOrderSwapBuy ? (
        <IonFooter className='footer-btn-wrap'>
          {doComboType === 'OptionalCombo' && <AboardOptionalGroupCart />}
          {
            disableReserve ? (
              <div className='footer-btn'>
                <div className='primary-btn disabled'>{i18n.t('newCart.noInReserveTime')}</div>
              </div>
            ) : disableTogo ? (
              <div className='footer-btn'>
                <div className='primary-btn disabled'>{i18n.t('newCart.canNotTogo')}</div>
              </div>
            ) : (
              <div className='footer-btn'>
                {targetPk && <div className={classNames('primary-btn', { 'disabled': doComboType !== 'OptionalCombo' && !doComboMobx.doComboResult.isReady })} data-cypid='comboDetailConfirm' onClick={handleExChange}>{i18n.t('newCart.confirmExChange')}</div>}
                {doComboMobx.doCombo.isOrderSwapBuy && <div className={classNames('primary-btn', { 'disabled': doComboType !== 'OptionalCombo' && !doComboMobx.doComboResult.isReady })} data-cypid='comboDetailConfirm' onClick={handleOrderSwaBuy}>{i18n.t('newCart.confirmExChange')}</div>}
              </div>
            )
          }
        </IonFooter>
      ) : (
        <Footer
          disabled={doComboType !== 'OptionalCombo' && !doComboMobx.doComboResult.isReady}
          soldOut={doComboMobx.doCombo.saleCnt === 0}
          disableTogo={disableTogo}
          disableReserve={disableReserve}
          restingStore={isRestingStore}
          pauseAllEatType={!isCanAddCart}
          cnt={doComboMobx.doCombo.cnt}
          maxCnt={maxCnt}
          modalFrom={doComboMobx.doCombo.pk ? 'cart' : 'menu'}
          setCnt={(value) => {
            doComboMobx.setCnt(value)
          }}
          resetCart={() => {
            doComboMobx.reset()
          }}
          totalPrice={doComboMobx.doComboResult.totalPrice}
          totalActualPrice={doComboMobx.doComboResult.totalActualPrice}
          hasStepper={doComboType === 'FixedCombo'}
          hasResetBtn={doComboType === 'OptionalCombo'}
          CustomCom={doComboType === 'OptionalCombo' && <AboardOptionalGroupCart />}
          addToCart={() => {
            if (doComboMobx.checkInvalid()) {
              showMsg(
                i18n.t('productdetail.saleOutTips2', {
                  count:
                    productSaleMobx.scaleNoToCntMap[
                      `${doComboMobx.doCombo.no}_${doComboMobx.doCombo.scaleNo}`
                    ]?.cnt ||
                    productSaleMobx.menuProductNoToCntMap[
                      `${doComboMobx.doCombo.no}`
                    ]?.cnt,
                })
              )
              return
            }
            if (doComboType === 'OptionalCombo') {
              if (doComboMobx.doCombo.productGroups?.some(group => group.productGroupDetails?.length !== group.selectMin)) {
                toastLayer.info(i18n.t('newCart.groupNotFull'))
                return
              } else if (doComboMobx.notReadyProduct.length) {
                modalLayer(SelectProductModal, { type: 'add', products: doComboMobx.notReadyProduct }, 'SelectProductModal').then((product: any) => {
                  if (product) {
                    doProductMobx.pick({ cartItem: product, groupNo: product.groupNo, isCombo: true, addPrice: product.addPrice })
                    CashierController.openProductDetail(product, {
                      type: 'combo',
                      scaleNo: product.scaleNo,
                      targetNo: product.groupNo,
                    })
                  }
                }, () => { })
              }
            }
            if (doComboMobx.doComboResult.isReady) {
              if (doComboMobx.doCombo && doComboMobx.doCombo.cnt) {
                CashierController.handleAddToCart(doComboMobx.doCombo.type, () => {
                  handleBack()
                  if (doComboMobx.doComboExt.thirdCouponCheckCB) { // 三方券来的
                    doComboMobx.doComboExt.thirdCouponCheckCB({ status: 'success', type: 'addCart' })
                  }
                })
              } else {
                cartMobx.remove(doComboMobx.doCombo.pk)
                handleBack()
              }
            } else {
              handleScollWrong()
            }
          }}
        />
      )}
    </>
  )
}

export default observer(ComboDetail)
